// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SplitSection-module--wrapper--VrH-S","split":"SplitSection-module--split--27rti"};